<template>
  <div :class="if_selected">
    <div slot="default" style="width: 100%">
      <div :class="title_component">
        <!-- possibility to replay only video with pointer_event:auto, default is "pointer_event:none" -->
        <div class="card" :style="this.config.attributes.style">
          <img class="card-img-top" :src="poster" alt="Card image cap" />
          <div class="card-body">
            <p class="card-text">
              <Message
                class="h5 m-1"
                :msg="`${this.config.attributes.text}`"
              ></Message>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";
import Message from "ireal-vue/components/MessageComponent.vue";

export default {
  name: "file-output-component",
  mixins: [dataComponentMixin, inputComponentMixin],
  components: { Message },
  data() {
    return {
      poster: "",
      list_model: [],
      if_selected: "",
    };
  },
  async created() {
    this.definitions = this.config.elements;
  },
  async mounted() {

  },
  methods: {
    prepare() {},
    getIndexByValue(data) {
      return data.filter((data) => {
        return data.time < this.$store.getters.progress;
      });
    },
    tickFlux(data) {
      if (data[0]){
        var source = JSON.parse(data[0].raw_value)
        this.poster = source["src"]
      }
    },
    tick() {
    this.value = this.getDataForFlux(this.attributes.name).number_value;
      // Updates the DOM for each flux (rendering)

      let flux_structure = this.getFluxStructure(this.attributes.name);
      this.tickFlux(flux_structure.data);

      //console.log(this.timeStart, flux_structure.dataLoaded)

    },
    componentStartEvent() {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: this.attributes.name,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      this.getTimeData(params);
      // retourne toutes les promesses, lorsqu'elles sont toutes résolues. Sinon, le mounted subira une erreur au niveau du then
    },
    setModelPoster() {
      if (this.attributes.poster === undefined) return [];
      else return this.attributes.poster.split("|");
    },
    setPoster(value) {
      value = value ? `${value}` : "";
      this.poster = `${this.IREALCONFIG.static_ressources}/labs/${this.$store.getters.experienceIdentifier}/${value}_poster.jpg`;
    }
  },
};
</script>
<style scoped>
.portrait {
  min-height: 50vh !important;
}
</style>
<style src="video.js/dist/video-js.css"></style>
